import * as React from "react";
const SvgMinus100Default = (props) => /* @__PURE__ */ React.createElement("svg", { width: "current", height: "current", viewBox: "0 0 14 15", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M2.5 7.98828H11.5", stroke: "currentColor", strokeLinecap: "round" }));
export default SvgMinus100Default;
